import { useState } from "react";

const ContactForm = () => {
  const [contactMethod, setContactMethod] = useState("email");

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (contactMethod === "whatsapp") {
      const name = e.target.name.value;
      const message = e.target.message.value;
      const phoneNumber = "+6285704134504";
      const whatsappText = `Hello Rifal, my name is ${name}. I saw your portfolio and would like to talk about: ${message}`;
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
        whatsappText
      )}`;
      window.open(whatsappUrl, "_blank");
    } else {
      const name = e.target.name.value;
      const message = e.target.message.value;
      const emailAddress = "alirifal485@gmail.com";
      const emailText = `Hello Rifal, my name is ${name}. I saw your portfolio and would like to talk about: ${message}`;
      const emailUrl = `mailto:${emailAddress}?subject=${encodeURIComponent(
        "Hi!"
      )}&body=${emailText}`;
      window.open(emailUrl, "_blank");
      e.target.reset();
    }
  };

  return (
    <div className="bg-white p-8 rounded-xl shadow-2xl h-full flex flex-col">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 border-b pb-2">
        Send a Direct Message
      </h2>

      <div className="flex bg-gray-100 rounded-lg p-1 mb-6">
        <button
          onClick={() => setContactMethod("email")}
          className={`flex-1 text-center py-2 text-sm font-semibold rounded-lg transition duration-200 ${
            contactMethod === "email"
              ? "bg-crimson text-white shadow-md"
              : "text-gray-600 hover:bg-gray-200"
          }`}
        >
          Email
        </button>
        <button
          onClick={() => setContactMethod("whatsapp")}
          className={`flex-1 text-center py-2 text-sm font-semibold rounded-lg transition duration-200 ${
            contactMethod === "whatsapp"
              ? "bg-green-500 text-white shadow-md"
              : "text-gray-600 hover:bg-gray-200"
          }`}
        >
          WhatsApp
        </button>
      </div>

      <form onSubmit={handleFormSubmit} className="space-y-4 flex-grow">
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700"
          >
            Name
          </label>
          <input
            type="text"
            name="name"
            id="name"
            required
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-3 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div className="flex-grow">
          <label
            htmlFor="message"
            className="block text-sm font-medium text-gray-700"
          >
            Message
          </label>
          <textarea
            name="message"
            id="message"
            rows="4"
            required
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-3 focus:ring-blue-500 focus:border-blue-500"
          ></textarea>
        </div>

        <button
          type="submit"
          className={`w-full py-3 px-4 border border-transparent rounded-lg text-white font-semibold shadow-lg transition duration-300 ease-in-out mt-auto ${
            contactMethod === "email"
              ? "bg-crimson hover:bg-blue-600 focus:ring-4 focus:ring-crimson focus:ring-opacity-50"
              : "bg-green-600 hover:bg-green-700 focus:ring-4 focus:ring-green-500 focus:ring-opacity-50"
          }`}
        >
          {contactMethod === "email" ? "Send Email" : "Chat on WhatsApp"}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
